module.exports = "https://coursera_assets.s3.amazonaws.com/images/c825d18ec0d28c6a626b6385fdfdd837.png";